import * as React from "react";
import App from "./App";

/**
 * Simple wrapper component - no Router needed since we're already inside a BrowserRouter
 * The routes in App.tsx will be automatically prefixed by the parent route /jainboarding-admin/*
 */
const AppWrapper = () => {
  return <App />;
};

export default AppWrapper;
